import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DOOD_API } from '@config/ws.config';
import { CrossSellingProposals } from '@store/cross-selling/cross-selling.model';

export interface CrossSellingRequest {
  trigger_product_id: string;
  trigger_product_shop_id: string;
  order: any;
}

@Injectable({ providedIn: 'root' })
export class CrossSellingApiService {
  private readonly httpClient = inject(HttpClient);

  /**
   * Get cross-selling product suggestions
   * @param request - Cross-selling suggestion request data
   * @returns Observable containing the list of suggested cross-selling products
   */
  public getCrossSellingSuggestions$(request: CrossSellingRequest) {
    return this.httpClient.post<CrossSellingProposals | null>(
      `${DOOD_API}/plugins/revenue-optimization/cross-selling/propose`,
      request,
    );
  }
}
